var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#instagram-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#472179",
  d: "M16.045 0H5.955A5.96 5.96 0 0 0 0 5.955v10.09A5.96 5.96 0 0 0 5.955 22h10.09A5.96 5.96 0 0 0 22 16.045V5.955A5.96 5.96 0 0 0 16.045 0m4.665 16.045a4.67 4.67 0 0 1-4.665 4.665H5.955a4.67 4.67 0 0 1-4.665-4.665V5.955A4.67 4.67 0 0 1 5.955 1.29h10.09a4.67 4.67 0 0 1 4.665 4.665z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#472179",
  stroke: "#472179",
  strokeWidth: 0.05,
  d: "M11.5 5.975A5.53 5.53 0 0 0 5.975 11.5a5.53 5.53 0 0 0 5.525 5.525 5.53 5.53 0 0 0 5.525-5.525A5.53 5.53 0 0 0 11.5 5.975Zm0 9.82A4.3 4.3 0 0 1 7.204 11.5 4.3 4.3 0 0 1 11.5 7.204a4.3 4.3 0 0 1 4.296 4.296 4.3 4.3 0 0 1-4.296 4.296Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 0.6,
  d: "M18.3 5a1.3 1.3 0 1 0-2.6 0 1.3 1.3 0 0 0 2.6 0Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "instagram-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h22v22H0z"
})))));
export default SvgInstagramDark;